export default __webpack_public_path__ + "static/media/fa-upload-white.2e78000e.svg";